import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=20594620&scoped=true&lang=pug&"
import script from "./Request.vue?vue&type=script&lang=ts&"
export * from "./Request.vue?vue&type=script&lang=ts&"
import style0 from "./Request.vue?vue&type=style&index=0&id=20594620&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20594620",
  null
  
)

export default component.exports